import 'animate.css'
import axios from 'axios'
import Element from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import en from 'element-ui/lib/locale/lang/en'
import 'es6-promise/auto'
import 'flag-icon-css/css/flag-icon.css' // 图标
// import '../node_modules/mdi/scss/materialdesignicons.scss'
import 'flex.box'
import jwt from 'jsonwebtoken'
import moment from 'moment'
// import 'es7-shim'
import Vue from 'vue'
// import 'highlight.js/styles/color-brewer.css'
// import 'vue-resize/dist/vue-resize.css'
import VueFloatLabel from 'vue-float-label'
// import 'viewerjs/dist/viewer.css'
import Fullscreen from 'vue-fullscreen'
import VueI18n from 'vue-i18n'
import myVideo from 'vue-video'
import VideoPlayer from 'vue-video-player'
import Vuebar from 'vuebar'
// import 'mavon-editor/dist/css/index.css'
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
// import 'vue-status-indicator/styles.css'
import Bars from 'vuebars'
import XLSX from 'xlsx'
import '../theme/index.css'
import promiseApi from './api/api'
import _request from './api/request'
import transactionServiceApi from './api/transactionService-api'
import userAdminApi from './api/user-admin-api'
import App from './App.vue'
import './assets/css/font.css'
// import language from './assets/language'
import language from './assets/lang'
import './assets/scss/global.scss'
// import Store from './Store/index.js'
// import i18n_messages from './i18n.json'
import bView from './components/index'
import VuePerfectScrollbar from './components/vue-ps'
import SecurityService from './js/util/SecurityService.js'
import router from './router/'
import store from './store/index.js'
import Util from './util/util'
// import './mock/mockServer'
Vue.use(VideoPlayer)
// require videojs style
// import 'vue-video-player/src/custom-theme.css'

Vue.use(myVideo)
/**
 * 导出数据报表xlsx文件
 * 已注入所有Vue实例，
 * template模板里调用 $$outputXlsxFile
 * 组件方法里调用 this.$outputXlsxFile
 * 例：this.$outputXlsxFile([['字段1', '字段2'], [1, 2]], [{wch: 10}, {wch: 50}], '测试导出') 得到 测试导出.xlsx 文件
 * 第一个参数是导出的数组对象，第二个参数是设置字段宽度，第三个参数是文件名
 */
// import 'muse-ui/lib/styles/base.less';
// import {DateInput} from 'muse-ui';
// import 'muse-ui/lib/styles/theme.less';

// Vue.use(DateInput);

// const languageObj = language.getLang()
const outputXlsxFile = (data, wscols, xlsxName) => {
  /* convert state to workbook */
  const ws = XLSX.utils.aoa_to_sheet(data)
  ws['!cols'] = wscols
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, xlsxName)
  /* generate file and send to client */
  XLSX.writeFile(wb, xlsxName + '.xlsx')
}
Vue.prototype.$outputXlsxFile = outputXlsxFile

axios.defaults.withCredentials = false
Vue.prototype.$request = _request

Vue.prototype.$http = axios
Vue.prototype.Util = Util
Vue.prototype.$api = promiseApi
Vue.prototype.$user_admin_api = userAdminApi
Vue.prototype.$transactionServiceApi = transactionServiceApi
Vue.prototype.$oAuth = new SecurityService()
Vue.config.productionTip = false
Vue.use(Bars)
Vue.use(bView)
Vue.use(VueFloatLabel)
Vue.use(Fullscreen)
Vue.use(VueI18n)
Vue.use(Element, {
  locale: sessionStorage.getItem('language') === 'en' ? en : locale
})
Vue.use(Vuebar)
Vue.prototype.openMessage = function (type, message, _duration) {
  let msg = {}
  msg.type = type
  msg.message = message
  msg.showClose = true
  if (!_duration) {
    msg.duration = _duration === 0 ? _duration : 3000
  } else {
    msg.duration = _duration
  }
  if (type !== 'error') return this.$message(msg)
  this.$message.error(message)
}
// window.postMessage('网页向rn发送的消息')
// window.document.addEventListener('message', function (e) {
//   const message = e.data
//   alert(message)
// })
Vue.prototype.$getProfile = function () {
  let token = Util.getToken()
  let profile = null
  let idToken = token.idToken
  if (idToken) {
    const decoded = jwt.decode(idToken, {
      complete: true
    })
    profile = decoded.payload
    store.commit('setUser', { profile: profile })
  }
  return profile
}

Vue.prototype.$getCurrencyIocn = function () {
  return JSON.parse(process.env.VUE_APP_CURRENCY_IOCN)
}

let languageM = sessionStorage.getItem('language') || 'cn'
let curLang = ''
if (Util.getUrlKey('lang')) {
  languageM = Util.getUrlKey('lang')
}
switch (languageM) {
  case 'en':
    curLang = 'en'
    break
  case 'zh-hant':
    curLang = 'hk'
    break
  case 'zh-hans':
    curLang = 'cn'
    break
  case 'cn':
    curLang = 'cn'
    break
  case 'hk':
    curLang = 'hk'
    break
  default:
    curLang = 'cn'
    break
}

sessionStorage.setItem('language', curLang)
Vue.component('vue-scroll', VuePerfectScrollbar)
const i18n = new VueI18n({
  locale: curLang,
  messages: language
})
// 注册一个全局指令v-focus
Vue.directive('focus', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function (el) {
    // 聚焦元素
    el.focus()
  }
})

Vue.filter('date-str', function (value, format = 'YYYY-MM-DD HH:mm:ss') {
  return moment(value).format(format)
})

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
  created: function () {
    Vue.prototype.$vmElement = this
  }
}).$mount('#app')
